import React from 'react';
import { Button, Spin } from 'antd';

export type QuickPaymentMethod = { id: number; name: string };

type QuickPaymentMethodsProps = {
  methods: QuickPaymentMethod[];
  selectedMethodId?: number | null;
  onSelect: (methodId: number) => void;
  disabled?: boolean;
  loading?: boolean;
};

export const QuickPaymentMethods: React.FC<QuickPaymentMethodsProps> = ({
  methods,
  selectedMethodId,
  onSelect,
  disabled = false,
  loading = false,
}) => {
  if (loading) {
    return <div className="pos-quick-payments__loading"><Spin size="small" /></div>;
  }

  if (methods.length === 0) {
    return <p className="pos-quick-payments__empty">No hay métodos de pago activos.</p>;
  }

  return (
    <div className="pos-quick-payments" aria-label="Métodos de pago rápidos">
      <div className="pos-quick-payments__grid">
        {methods.slice(0, 4).map((method) => (
          <Button
            key={method.id}
            type={selectedMethodId === method.id ? 'primary' : 'default'}
            className="pos-quick-payments__button"
            disabled={disabled}
            onClick={() => onSelect(method.id)}
          >
            {method.name}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickPaymentMethods;
